import OnlineImg from "../../../images/Online.svg"
import {useEffect, useState} from "react"
import {useTranslation} from "react-i18next";
import {Cookies} from "react-cookie";
import instance from "../../../api/axios";
import { useCart } from "../../../context/CartContext";

const Online = () => {

    const [addHeader, setaddHeaders] = useState()

    let url = process.env.REACT_APP_BASE_URL;


    const {t, i18n} = useTranslation()


    const fetchCatalogPosts = async (lng) => {
        let lang = lng.slice(0, 2)

        await instance.get(`${url}/abio/public/products/code/888001?`,
            {
                params: {
                    language: lang
                }
            }
        )
            .then(res => setaddHeaders(res.data))
            .catch(er => console.log(er))
    }

    useEffect(() => {
        fetchCatalogPosts(i18n.language)

    }, [i18n.language]);


    const { addProduct } = useCart();

    const onAdd = (prod) => {
        addProduct(prod);  // GTM + refresh cart + backend call
    };

    return (
        <>
            <p className="services__global">{t("ServicesOnline.online")}</p>

            <div className="services__info">
                <div className="services__img"><img src={OnlineImg} alt="Online"/></div>
                <div className="services__txt">
                    <p>{t("ServicesOnline.online")}</p>
                    <p>{t("ServicesOnline.request")}</p>
                    <p>{t("ServicesOnline.determine")}</p>
                    <p>{t("ServicesOnline.care")}</p>
                    <p>{t("ServicesOnline.case")}</p>
                    <p>{t("ServicesOnline.forOnline2")}</p>
                    <p>{t("ServicesOnline.forOnline3")}</p>
                    <strong>{t("ServicesOnline.cost")} {addHeader?.price ? addHeader?.price : 600} AMD</strong>


                </div>
                {/*<div>*/}
                {/*    <Link to='/tabs'>*/}
                {/*        <button className="services__btn" onClick={() => onAdd(addHeader?.productCode)}>*/}
                {/*            {t("ServicesOnline.btnService")}*/}
                {/*        </button>*/}
                {/*    </Link>*/}
                {/*</div>*/}
            </div>

        </>
    )
}
export {Online}